export default "__VITE_ASSET__CN_J9CSv__";